export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const SET_API_GATEWAY_CLIENT = 'SET_API_GATEWAY_CLIENT';

export const USER_INVITE = 'users/USER_INVITE';
export const USER_INVITE_RESEND = 'users/USER_INVITE_RESEND';
export const USER_INVITE_CANCEL = 'users/USER_INVITE_CANCEL';
